module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-container"
  }, [(_vm.ready) ? _c('md-layout', {
    attrs: {
      "md-vertical-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "35",
      "md-align": "center"
    }
  }, [_c('h1', [_c('img', {
    attrs: {
      "src": require('../assets/img/cuelistBLACK.png'),
      "alt": "LOGO"
    }
  })])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h1', {
    staticClass: "md-headline"
  }, [_vm._v("Collaborate on "), _c('strong', [_vm._v(_vm._s(_vm.project.title))])])]), _vm._v(" "), (_vm.validCollab) ? _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.accept
    }
  }, [_c('md-icon', [_vm._v("person")]), _vm._v(" Accept Invite")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.validCollab) ? _c('md-layout', {
    attrs: {
      "md-flex": "100",
      "md-align": "center"
    }
  }, [_c('h2', {
    staticClass: "md-title"
  }, [_vm._v("You have not been invited to this project.")])]) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3818738","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/views/accept-invite.vue
// module id = 675
// module chunks = 2